import { i18n } from '@/iti-core-vue';
import Vue from 'vue';
import EventBusType, { EventBus } from '@/shared/services/event-bus';
import { Ref, Prop, Model } from 'vue-property-decorator';
import { extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
export class ItiBaseEditor extends Vue {
    @Prop() public name!: any;
    @Prop() public rules!: any;
    @Prop() public label!: string;
    @Prop() public disabled!: boolean;
    @Model('change') public model!: string;

    @Ref('validationProvider') public validationProvider!: any;
    
    public get validationProviderName() {
        return this.name || this.label;
    }

    public created() {
        EventBus.$on(EventBusType.cleanValidators, () => {
            if (this.validationProvider) {
                this.validationProvider.reset();
            }
        });
        extend('required', {
            ...required,
            message: i18n.tc('rules.required')
        });
    }

    public get value() {
        return this.model;
    }

    public set value(newValue: string) {
        this.$emit('change', newValue);
    }
}